import { T } from "../../util/t";
import { Typography, Box } from "@mui/material";
import { PriceDescriptions } from "../registration/selectOptionsField/PriceDescriptions";

const showPricingDetails = (event) => {
    const paymentOptions = event.paymentOptions;
    return (event.status === "upcoming") && paymentOptions &&
        (paymentOptions.defaultDivisionPrice != null || paymentOptions.extraDivisionPrice != null || paymentOptions.divisions || paymentOptions.familyTotal);
};

export const EventPricing = ({ event }) => {
    if (!showPricingDetails(event)) return null;

    return (
        <Box component="section" marginTop={2} marginX={0} marginBottom={3}>
            <Typography variant="subtitle2"><T>Entry fees</T></Typography>
            <Typography variant="body1" component="h2" marginTop={3} marginX={0} marginBottom={2}>
                <PriceDescriptions registrationOptions={event.registrationOptions} paymentOptions={event.paymentOptions} totalDivisions={event.eventDivisions.length} />
            </Typography>
        </Box>
    );
};
